var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Cta',{attrs:{"data":Object.assign({}, {icon: _vm.data.icon ? _vm.data.icon : _vm.added ? 'minus' : 'plus',
      title: _vm.data.label ? _vm.data.label : _vm.added ? _vm.$labels.remove : _vm.$labels.collection_cta},
      _vm.data),"theme":_vm.added || _vm.data.action === 'clear' ? 'red' : 'default'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }